/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * Returns List of StoreInfo
 */

import React, { Component } from 'react';

export interface IStoreInfo {
  storeFilter?: string;
  clickToCall?: string;
  callNumber?: string;
  storeImageURL?: string;
  storeName?: string;
  googleMap?: string;
  wpLogo?: string;
  wpClick?: string;
}

/**
 *
 * StoreInfo component
 * @extends {React.PureComponent<IOurStoresProps<IOurStoresData>>}
 */

export class StoreInfo extends Component {
  private readonly storeData: IStoreInfo[] = [
    {
      callNumber: '٠١٢٦١٨٤٢٠٣',
      clickToCall: 'tel:0126184203',
      storeFilter: '1',
      storeImageURL:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/ME3Zft?pubver=1',
      storeName: 'jeddah',
      googleMap: 'https://goo.gl/maps/WtE2YzvSFX4YgBxW9',
      wpClick: 'https://api.whatsapp.com/send?phone=966126184203',
    },
    {
      callNumber: '٠١٢٦١٨٤١١٩',
      clickToCall: 'tel:0126184119',
      storeFilter: '1',
      storeImageURL:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/ME41PN?pubver=1',
      storeName: 'jeddah',
      googleMap: 'https://goo.gl/maps/zXkUh6FXt8ZX7zcn9',
      wpClick: 'https://api.whatsapp.com/send?phone=966126184119',
    },
    {
      callNumber: '٠١٢٦١٨٤١١٢',
      clickToCall: 'tel:0126184112',
      storeFilter: '5',
      storeImageURL:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/ME3WCz?pubver=1',
      storeName: 'madinah',
      googleMap: 'https://goo.gl/maps/ykqCoVXj623AAFTj9',
      wpClick: 'https://api.whatsapp.com/send?phone=966126184112',
    },
    {
      callNumber: '٠١٢٦١٨٤٢٠٧',
      clickToCall: 'tel:0126184207',
      storeFilter: '2',
      storeImageURL:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/ME3WCL?pubver=1',
      storeName: 'riyadh',
      googleMap: 'https://goo.gl/maps/CSnFEtVDHbFsW7PL6',
      wpClick: 'https://api.whatsapp.com/send?phone=966126184207',
    },
    // {
    //   callNumber: '٠١٢٦١٨٤٢٠٨',
    //   clickToCall: 'tel:0126184208',
    //   storeFilter: '2',
    //   storeImageURL:
    //     'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/ME41PU?pubver=1',
    //   storeName: 'riyadh',
    //   googleMap: 'https://goo.gl/maps/JiU2NPqFA7evVT156',
    //   wpClick: 'https://api.whatsapp.com/send?phone=966126184208',
    // },
    {
      callNumber: '٠١٢٦١٨٤١١٨',
      clickToCall: 'tel:0126184118',
      storeFilter: '2',
      storeImageURL:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/ME3ZfH?pubver=1',
      storeName: 'riyadh',
      googleMap: 'https://goo.gl/maps/upMSpxCtCiBsBnWD6',
      wpClick: 'https://api.whatsapp.com/send?phone=966126184118',
    },
    // {
    //   callNumber: '٠١٢٦١٨٤١٢٣',
    //   clickToCall: 'tel:0126184123',
    //   storeFilter: '2',
    //   storeImageURL:
    //     'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/ME3WCC?pubver=1',
    //   storeName: 'riyadh',
    //   googleMap: 'https://goo.gl/maps/89EySugBneUPG5ZA9',
    //   wpClick: 'https://api.whatsapp.com/send?phone=966126184123',
    // },
    {
      callNumber: '٠١٢٦١٨٤٢٠٤',
      clickToCall: 'tel:0126184204',
      storeFilter: '7',
      storeImageURL:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/ME41PI?pubver=1',
      storeName: 'dhahran',
      googleMap: 'https://goo.gl/maps/xwhs75UaoFURRHA79',
      wpClick: 'https://api.whatsapp.com/send?phone=966126184204',
    },
    {
      callNumber: '٠١٢٦١٨٤١١٤',
      clickToCall: 'tel:0126184114',
      storeFilter: '8',
      storeImageURL:
        'https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/ME41PE?pubver=1',
      storeName: 'dammam',
      googleMap: 'https://goo.gl/maps/pHgEJnjekZFE4FeeA',
      wpClick: 'https://api.whatsapp.com/send?phone=966126184114',
    },    
  ];
  public render(): JSX.Element | null {
    return (
      <React.Fragment>
        {this.storeData.map((item) => (
          <div
            className='col-md-4 col-sm-6 col-xs-12  filtr-item'
            data-category={item.storeFilter}
          >
            <div className='imagecover'>
              <img
                className='img-responsive'
                src={item.storeImageURL}
                alt={item.storeName}
              />
              <a
                href={item.googleMap}
                target='_blank'
                className='store-location-link-new'
              >
                <img
                  className='store-location-google-logo-width'
                  src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD3JwS?pubver=1'
                  alt='WP logo'
                />
                اذهب إلى الموقع
              </a>

              <div className='store-location-wp-p'>
                <a
                  href={item.wpClick}
                  target='_blank'
                  className='store-location-wp-button'
                >
                  <img
                    className='store-location-wp-logo-width'
                    src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD3z9c?pubver=1'
                    alt='WP logo'
                  />
                </a>
              </div>
              <div className='store-location-call'>
                <a href={item.clickToCall}>
                  <img
                    className='store-location-call-logo-width'
                    src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/smslnvtclk/imageFileData/MD3z99'
                    alt='call logo'
                  />
                  <span className='store-location-call-text'>
                    {item.callNumber}
                  </span>
                </a>
              </div>
            </div>
          </div>
        ))}
      </React.Fragment>
    );
  }
}

export default StoreInfo;
